export default [{
	titulo: 'Plano M de Educação',
	icone: 'menu-icon fa fa-caret-right',
	url: '/links/pme',
	visualizar: false,
	actions: [{
		value: false,
		name: 'Cadastrar'
	}, {
		value: false,
		name: 'Editar'
	}, {
		value: false,
		name: 'Apagar'
	}]
}]